import React from 'react';
import { IStage as Stage } from '../../../../global';
import { debounce } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import StageColor from './StageColor';
import StageName from '../Stages/StageName';
import StageAmount from './StageAmount';
import StageDate from './StageDate';
import StageEdit from './StageEdit';
import DeleteStage from './DeleteStage';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

const useStyles = makeStyles((theme: any) => ({
  root: {
    background: ({ edit }: { edit: boolean }) =>
      edit ? theme.palette.brand.white : theme.palette.brand.greyLight3,
    border: ({ edit }: { edit: boolean }) =>
      edit ? `2px solid ${theme.palette.brand.greenNature}` : 'none',
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
    width: '100%',
    height: ({ edit }: { edit: boolean }) => (edit ? 'inherit' : 48),
  },
  stage: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },
  stageContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
}));

interface Props {
  stage: Stage;
  handleStageUpdate: (...args) => void;
  addOrDeleteError: (...args) => void;
}

export default function MobileStage({
  stage,
  handleStageUpdate,
  addOrDeleteError,
}: Props) {
  const { id, name, amount, start, edit } = stage;

  const classes = useStyles({ edit });

  const editStage = debounce((state: boolean) => {
    if (edit !== state) {
      handleStageUpdate(id, 'edit', state);
    }
  }, 10);

  return (
    <ClickAwayListener onClickAway={() => editStage(false)}>
      <div className={classes.root}>
        <div className={classes.stage} onClick={() => editStage(true)}>
          <StageColor name={name} />
          <div className={classes.stageContent}>
            <StageName
              stage={stage}
              handleStageUpdate={handleStageUpdate}
              edit={edit}
            />
            {edit && (
              <DeleteStage id={id} handleStageUpdate={handleStageUpdate} />
            )}
            {!edit && (
              <>
                <StageAmount amount={amount} />
                <StageDate date={start} />
              </>
            )}
          </div>
        </div>
        {edit && (
          <StageEdit
            stage={stage}
            handleStageUpdate={handleStageUpdate}
            addOrDeleteError={addOrDeleteError}
          />
        )}
      </div>
    </ClickAwayListener>
  );
}
